import {imageLocations} from "../image/ImageLocations";
import React from "react";
import './Layout.css';
import {BannerImage} from "../image/BannerImage";


// Use on pages that need a banner but do not show My Vehicle

const HeaderBanner = () => {
    return (
        <div className="dp-header-top-banner">
            <BannerImage imageSrc={imageLocations.NIGHT_BANNER_IMAGE} />
        </div>
    )
}

export default HeaderBanner;